import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import ExecutiveOffice from "@/pages/ExecutiveOffice";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import { authMe } from "@/lib/api";
import { Loader2 } from "lucide-react";

function AuthGate() {
  const [user, setUser] = useState(null); // null=checking, false=unauth, object=authed
  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return; // callback handles it
    authMe().then(setUser).catch(() => setUser(false));
  }, []);

  if (user === null) {
    return (
      <div className="min-h-screen bg-[#0A0908] grid place-items-center">
        <div className="flex items-center gap-2 text-amber-400"><Loader2 className="animate-spin" /> Opening your office…</div>
      </div>
    );
  }
  if (user === false) return <Login />;
  return <ExecutiveOffice user={user} />;
}

function AppInner() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return <AuthGate />;
}

function App() {
  return (
    <BrowserRouter>
      <AppInner />
    </BrowserRouter>
  );
}

export default App;
